export default __webpack_public_path__ + "img/adef1c054b31acd42218c97e5caee4fe.jpg";